import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import FormInputContainer from "./form-input-container";

// const SizeAlign = ReactQuill.Quill.import("attributors/style/align");
// ReactQuill.Quill.register(SizeAlign, true);

type FormQuillProps = {
  label: string;
  description?: string;
  disabled?: boolean | string;
  value: string;
  onChange: (v: string) => void;
};

export default function FormQuill({
  label,
  description,
  disabled,
  value,
  onChange,
}: FormQuillProps) {
  return (
    <FormInputContainer
      disabled={disabled}
      label={label}
      description={description}
    >
      <ReactQuill
        className="flex-1 flex flex-col"
        theme="snow"
        value={value}
        formats={[
          "header",
          "bold",
          "italic",
          "underline",
          "strike",
          "blockquote",
          "list",
          "bullet",
          "link",
          "image",
          "align",
        ]}
        modules={{
          toolbar: [
            ["bold", "italic", "underline"],
            [
              { align: "" },
              { align: "center" },
              { align: "right" },
              { align: "justify" },
            ],
            [{ list: "ordered" }, { list: "bullet" }],
            ["link"],
          ],
        }}
        onChange={onChange}
      />
    </FormInputContainer>
  );
}
